export function getMessageProp(messageKey,messageProps,messages){return messageProps?.[messageKey]||messages[messageKey]}